import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";

// project related common imports

import lstModules from "common/json/lstModules.json";
import "common/css/master.css";
import Header from "common/js/header/header.js";
import ExamHeader from "./examDateHeader.js";
import EvaluationTable from "./EvaluationTable.js";
import EvaluateSlider from "./EvaluateSlider.js";
import "sms/tt/header/css/SectionList.css";

const EvaluateCtrl = (props) => {
  const [tableLoader, setTableLoader] = useState("none");
  const [sliderLoader, setSliderLoader] = useState("none");
  const [flgSlider, setFlgSlider] = useState(false);
  const [lstEvaluation, setLstEvaluation] = useState([]);
  const [examId, setExamId] = useState(0);
  const [sectionId, setSectionId] = useState(0);
  const [exam, setExam] = useState("");
  const [allocationId, setAllocationId] = useState(0);
  const [randNo, setRandNo] = useState(0);

  useEffect(() => {
    setAllocationId(props.allocationId);
  }, [props.allocationId]);

  function examClick(ExamId, Exam) {
    setExamId(ExamId);
    setExam(Exam);
    // console.log(ExamId);
  }

  function closeSlider() {
    setFlgSlider(false);
    generateRandNo();
    setAllocationId(0);
  }
  function setAllocationDtls(pAllocationId, pSectionId) {
    setAllocationId(pAllocationId);
    setSectionId(pSectionId);
  }
  async function openSlider(pExamObj) {
    // console.log(JSON.stringify(pExamObj));
    // console.log("allocationId = " + pExamObj.allocationId);
    // console.log("sectionId = " + pExamObj.sectionId);
    await setAllocationDtls(pExamObj.allocationId, pExamObj.sectionId);
    setFlgSlider(true);
  }
  function generateRandNo() {
    var lRandNo = Math.floor(Math.random() * 999999);
    setRandNo(lRandNo);
  }
  const getWingId = (wingId) => {
    // console.log("wingId" + wingId);
  };

  return (
    <div style={{ height: "100%" }}>
      <Header wingFromChild={getWingId} />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div className="MainContainer">
        <div
          className="col-md-10 col-centered wingsWrap clearfix"
          style={{ marginTop: "1%" }}
        >
          <ExamHeader examId={examId} examClick={examClick} />
        </div>
        <div className="col-md-11 col-centered clearfix">
          <div className="col-md-12">
            <div className="col-md-12  col-xs-12">
              <div
                style={{
                  position: "absolute",
                  zIndex: 10000,
                  width: 100,
                  height: 100,
                  marginLeft: -50,
                  marginTop: -50,
                  left: "50%",
                  top: "50%",
                  display: tableLoader,
                }}
              >
                <img
                  className="loderImg"
                  src={require("common/images/loader.gif")}
                  alt="Loader..."
                />
              </div>

              <EvaluationTable
                onEvaluateClick={openSlider}
                examId={examId}
                setAllocationId={setAllocationId}
              />
            </div>

            <div
              className="slider halfWidthSlider"
              style={{
                right: 0,
                opacity: 1,
                display: flgSlider === true ? "block" : "none",
                zIndex: 10000,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  zIndex: 10000,
                  width: 100,
                  height: 100,
                  marginLeft: -50,
                  marginTop: -50,
                  left: "50%",
                  top: "50%",
                  display: sliderLoader,
                }}
              >
                <img
                  className="loderImg"
                  src={require("common/images/loader.gif")}
                  alt="Loader..."
                />
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-info text-center btnCloseDiv"
                  onClick={(e) => closeSlider()}
                >
                  <span
                    id="close"
                    title="Close Slider"
                    className="glyphicon glyphicon-remove"
                  ></span>
                </button>
              </div>

              <EvaluateSlider
                key={allocationId}
                allocationId={allocationId}
                sectionId={sectionId}
                flgSlider={flgSlider}
                generateRandNo={generateRandNo}
                closeSlider={closeSlider}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvaluateCtrl;
